import { __extends } from "tslib";
/**
 * Created by Bogdan Kostka on 2017-10-04.
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/accordion.hbs';
import templateWithLabel from '../template/accordion-with-label.hbs';
import templateWithOtherComponent from '../template/accordion-with-other-component.hbs';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSAccordionComponent class
 */
var templateObject = {
    defaultTemplate: template,
    templateWithLabel: templateWithLabel,
    templateWithOtherComponent: templateWithOtherComponent,
};
var BSSAccordionComponent = /** @class */ (function (_super) {
    __extends(BSSAccordionComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSAccordionComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        /**
         * @desc hides accordion content
         * @private
         */
        _this._hideAccordionContent = function () {
            logger.info('AccordionComponent ' +
                _this._config.componentId +
                ' function : _hideAccordionContent');
            _this._$accordionContent.slideUp(_this._$animDuration);
            _this._$accordionArrow.removeClass(_this._arrowClass);
            _this._componentScope.removeClass(_this._activeClass);
        };
        _this._componentVersion = '@@name ver. @@version';
        logger.info('AccordionComponent ' +
            _this._config.componentId +
            ' has been successful render');
        /**
         * @desc accordion title element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$accordionTitle = _this._componentScope.find("#".concat(_this._config.componentId, "_title"));
        /**
         * @desc accordion content element which will be hidden or not
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$accordionContent = _this._componentScope.find("#".concat(_this._config.componentId, "_content"));
        /**
         * @desc active class on component root element
         * @type {string}
         * @private
         */
        _this._activeClass = _this._config.activeClass || 'bss-accordion_is-active';
        /**
         * @desc arrow class
         * @type {String}
         * @private
         */
        _this._arrowClass = _this._config.arrowClass
            ? _this._config.arrowClass
            : 'bss-accordion_rotate-arrow';
        /**
         * @desc duration of slideUp and slideDown animation
         * @type {Number}
         * @private
         */
        _this._$animDuration = _this._config.animDuration
            ? _this._config.animDuration
            : 400;
        /**
         * @desc accordion arrow element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$accordionArrow = _this._componentScope.find("#".concat(_this._config.componentId, "_arrow"));
        _this._$accordionTitle.on('click.' + _this._config.componentId, _this._onClickAccordion.bind(_this));
        // by default bottom part of accordion is hidden
        _this._$accordionContent.css('display', 'none');
        if (_this._config.minListSize && _this._config.listDataContext) {
            if (_this._config.listDataContext.length < _this._config.minListSize) {
                _this._componentScope.addClass('bss-accordion_hidden-list-active');
            }
            else {
                var appendText = '<span class="bss-accordion_list-count">(' +
                    _this._config.listDataContext.length +
                    ')</span>';
                _this._$accordionTitle
                    .find('.bss-accordion_label-text')
                    .append(appendText);
            }
        }
        if (_this._config.closeOnEvent) {
            _this._eventManager.subscribe(_this._config.closeOnEvent, _this._hideAccordionContent, _this.subscriberPrefix + _this._config.componentId);
        }
        return _this;
    }
    /**
     * @desc shows accordion content after click on arrow
     * @param {Event} accordionClickEvent accordion click event event object
     * @private
     */
    BSSAccordionComponent.prototype._showAccordionContent = function (accordionClickEvent) {
        var _a;
        logger.info('AccordionComponent ' +
            this._config.componentId +
            ' function : _showAccordionContent| Params: ', accordionClickEvent);
        this._$accordionContent.slideDown(this._$animDuration);
        this._$accordionArrow.addClass(this._arrowClass);
        this._componentScope.addClass(this._activeClass);
        var accordionOpenTagEvent = (((_a = this._config) === null || _a === void 0 ? void 0 : _a.tagEvent) || {}).accordionOpenTagEvent;
        if (accordionOpenTagEvent) {
            this._onTaggingEvent(accordionOpenTagEvent === null || accordionOpenTagEvent === void 0 ? void 0 : accordionOpenTagEvent.throwEvent, accordionOpenTagEvent === null || accordionOpenTagEvent === void 0 ? void 0 : accordionOpenTagEvent.throwAfterCalculation, accordionClickEvent);
        }
    };
    /**
     * @desc does action on accordion's title click
     * @param {Event} accordionClickEvent accordion click event event object
     * @private
     */
    BSSAccordionComponent.prototype._onClickAccordion = function (accordionClickEvent) {
        logger.info('AccordionComponent ' +
            this._config.componentId +
            ' function : _onClickAccordion| Params: ', accordionClickEvent);
        if (this._isAccordionContentVisible()) {
            this._hideAccordionContent();
        }
        else {
            this._showAccordionContent(accordionClickEvent);
        }
    };
    /**
     * @desc checks if accordion's content is visible or not
     * @return {boolean} true if bottom part of accordion is visible otherwise false
     * @private
     */
    BSSAccordionComponent.prototype._isAccordionContentVisible = function () {
        logger.info('AccordionComponent ' +
            this._config.componentId +
            ' function : _isAccordionContentVisible');
        return this._$accordionContent.css('display') === 'block';
    };
    /**
     * @desc prepares all form components for data binding
     * @param {Object} componentTemplates
     * @private
     */
    BSSAccordionComponent.prototype._setComponentTemplate = function (componentTemplates) {
        var _this = this;
        logger.info('AccordionComponent ' +
            this._config.componentId +
            ' => function : _setComponentTemplate| Params: ', componentTemplates);
        if (this._config.listDataName && !this._config.listDataContext) {
            try {
                if (Array.isArray(this._config.listDataName)) {
                    this._config.listDataContext = [];
                    this._config.listDataName.forEach(function (el) {
                        _this._config.listDataContext = _this._config.listDataContext.concat(_this._splitTextToArray(el));
                    });
                }
                else {
                    this._config.listDataContext = this._splitTextToArray(this._config.listDataName);
                }
                if (!this._config.listDataContext.length) {
                    this._config.class =
                        (this._config.class ? this._config.class : '') + ' hidden';
                }
            }
            catch (e) {
                logger.error('AccordionComponent: ' +
                    this._config.componentId +
                    ' => function : _setComponentTemplate' +
                    ' | listDataName split', this._config.listDataName);
            }
        }
        _super.prototype._setComponentTemplate.call(this, componentTemplates);
    };
    BSSAccordionComponent.prototype._splitTextToArray = function (el) {
        logger.info('AccordionComponent ' +
            this._config.componentId +
            ' => function : _splitTextToArray| Params: ', el);
        var parseName = el.split('.');
        var textArray;
        if (this._config.resultDataFlat) {
            textArray =
                this._toolbox.resultDataFlat[parseName[0]][parseName[1]] || [];
        }
        else {
            textArray = this._config.resultData[parseName[0]][parseName[1]] || [];
        }
        if (!Array.isArray(textArray)) {
            textArray = textArray.replace(/[\[]?[\]]?/g, '');
            if (textArray === '') {
                textArray = [];
            }
            else {
                textArray = textArray.split(',');
            }
        }
        return textArray;
    };
    /**
     * @desc base destroy method
     */
    BSSAccordionComponent.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this._$accordionArrow.removeClass('bss-accordion_rotate-arrow');
        this._componentScope.removeClass(this._activeClass);
        this._$accordionContent.css('display', 'none');
    };
    return BSSAccordionComponent;
}(BSSAbstractComponent));
export default BSSAccordionComponent;
